import React, { FC } from 'react';
import styled from 'styled-components';
import { UserRatingsResponse } from 'logic/api-models/api-models';
import { Stack } from 'components/stack/stack';
import { Text } from 'components/text/Text';
import { RoundImage } from 'components/RoundImage/RoundImage';
import {
  DateTranslationFormats,
  translateDateTime,
  translate,
  translationKeys,
} from 'logic/translations/translations.service';
import { ExpandableText } from './ExpandableText';
import { getImageSrc } from 'logic/utils/image';

type RatingElementModel = UserRatingsResponse['ratings'][0];

type Props = {
  author: RatingElementModel['addedBy'];
  comment: NonNullable<RatingElementModel['comment']>;
  createdAt: RatingElementModel['createdAt'];
};

const TopContent = styled.div`
  display: flex;
  margin-bottom: 12px;
  width: 100%;
`;

export const UserReview: FC<Props> = ({ author, comment, createdAt }) => {
  return (
    <Stack flow={'row'}>
      <TopContent>
        <RoundImage
          src={getImageSrc(author.imageUrl)}
          alt={`${author.firstName} ${author.lastName}`}
          size={56}
        />
        <Stack flow={'row'} style={{ marginLeft: 12 }}>
          <Text fontWeight={600} size={16}>
            {author.firstName}
          </Text>
          <Text size={16} fontWeight={400}>
            {translateDateTime(
              [DateTranslationFormats.MonthName, DateTranslationFormats.Year],
              createdAt ? new Date(createdAt) : undefined
            )}
          </Text>
        </Stack>
      </TopContent>
      <ExpandableText
        text={comment || ''}
        showMoreCTA={translate(translationKeys.ratings.showMoreCTA)}
      />
    </Stack>
  );
};
